import { render, staticRenderFns } from "./ProviderAdvisor.vue?vue&type=template&id=26863585&scoped=true&"
import script from "./ProviderAdvisor.vue?vue&type=script&lang=js&"
export * from "./ProviderAdvisor.vue?vue&type=script&lang=js&"
import style0 from "./ProviderAdvisor.vue?vue&type=style&index=0&id=26863585&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26863585",
  null
  
)

export default component.exports